<template>
  <div class="row main-content">
    <SocialBar/>
    <CreditoSimplePFComponent/>
  </div>
</template>

<script>
import CreditoSimplePFComponent from './components/CreditoSimplePFComponent.vue';
import SocialBar from './components/SocialBar.vue';


export default {
  name: 'CreditoSimplePF',
  components: {
    SocialBar,
    CreditoSimplePFComponent
  }
}

</script>